module.exports = __webpack_public_path__ + "img/folder_icon.6e7837b3.svg";